
export interface AuditStd_AuditStatus{
  AuditID:string,
  JobRunning:boolean,
  JobPosted:boolean,
  RequestedJobComplete:boolean,
  AmadeusPercentage:number,
  ApolloPercentage:number,
  GalileoPercentage:number,
  SabrePercentage:number,
  WorldspanPercentage:number,
}
